// extracted by mini-css-extract-plugin
export default {"intro-container":"IntroAnimation_intro-container__pvX+Y","fade-out":"IntroAnimation_fade-out__+nnRc","canvas":"IntroAnimation_canvas__fcJHv"};